module.exports = __webpack_public_path__ + "img/car_16.9c1b83ac.jpg";